var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "role": "status",
      "aria-label": "Page loading"
    }
  }, [_c('div', {
    class: _vm.headerClasses
  }, [(_vm.title) ? _c('polaris-display-text', {
    attrs: {
      "size": "large",
      "element": "h1"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.title) ? _c('polaris-skeleton-display-text', {
    attrs: {
      "size": "large"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-SkeletonPage__Actions"
  }, _vm._l((_vm.secondaryActions), function(action) {
    return _c('div', {
      staticClass: "Polaris-SkeletonPage__Action",
      style: ({
        width: (Math.round(Math.random() * 40 + 60)) + 'px'
      })
    }, [_c('polaris-skeleton-body-text', {
      attrs: {
        "lines": 1
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-SkeletonPage__Content"
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-456b524a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456b524a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisSkeletonPage.vue
// module id = 239
// module chunks = 0